import { Offer } from '../../../services/exports/Interfaces';
import { OfferKindEnum } from '../../../services/exports/Constants';
import useAppMethods from '../../../hooks/utility/useAppMethods';
import { useTranslation } from 'react-i18next';

const useOffersTranslations = () => {
  const { formatCurrency } = useAppMethods();
  const { t, i18n } = useTranslation(null, { keyPrefix: 'Features:Offers:OfferLabel' });

  const getLabelByOffer = (offer: Offer): string => {
    const aiGeneratedTitle = offer.translations?.[i18n.language]?.title;

    if (aiGeneratedTitle) {
      return aiGeneratedTitle;
    }

    return {
      [OfferKindEnum.PercentageOffByProducts]: t(OfferKindEnum.PercentageOffByProducts, {
        percentageAmount: offer.details.percentage_amount,
      }),
      [OfferKindEnum.PercentageOffByMinSpendValue]: t(OfferKindEnum.PercentageOffByMinSpendValue, {
        minSpendValue: formatCurrency(offer.details.min_spend_value),
        percentageAmount: offer.details.percentage_amount,
      }),
      [OfferKindEnum.AmountOffByProducts]: t(OfferKindEnum.AmountOffByProducts, {
        amount: formatCurrency(offer.details.amount),
      }),
      [OfferKindEnum.AmountOffByMinSpendValue]: t(OfferKindEnum.AmountOffByMinSpendValue, {
        amount: formatCurrency(offer.details.amount),
        minSpendValue: formatCurrency(offer.details.min_spend_value),
      }),
      [OfferKindEnum.Bogo]: t(OfferKindEnum.Bogo),
      [OfferKindEnum.BogoHalfPrice]: t(OfferKindEnum.BogoHalfPrice),
      [OfferKindEnum.FreeItemByProducts]: t(OfferKindEnum.FreeItemByProducts),
      [OfferKindEnum.FreeItemByMinSpendValue]: t(OfferKindEnum.FreeItemByMinSpendValue, {
        minSpendValue: formatCurrency(offer.details.min_spend_value),
      }),
    }[offer.kind];
  };

  return { getLabelByOffer };
};

export default useOffersTranslations;
